import { useQuery } from '@tanstack/react-query';

import { fetchImpacts } from '@/api/v4/impact.api';
import { QueryKey } from '@/config/query-client';
import type { IOption } from '@/types';

export const useImpactsOptions = () => {
  return useQuery({
    queryKey: [QueryKey.Impacts],
    queryFn: async (): Promise<IOption[]> => {
      const data = await fetchImpacts();

      return data.map(item => ({
        value: item.id,
        label: item.name,
      }));
    },
    staleTime: 1000 * 60 * 10,
  });
};
